/**
 * @param {EventTarget | null} target
 * @returns {boolean}
 */
function isEditableTarget(target) {
  if (!(target instanceof HTMLElement)) return false;

  const tagName = target.tagName;
  if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') {
    return true;
  }

  return target.isContentEditable;
}

/**
 * @param {HTMLElement} root
 */
function initDesignedByMf(root) {
  let isVisible = false;
  let mPressed = false;
  const abortController = new AbortController();
  const { signal } = abortController;

  /**
   * @param {boolean} nextVisible
   */
  const setVisible = (nextVisible) => {
    isVisible = nextVisible;
    root.classList.toggle('is-visible', isVisible);
    root.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    root.toggleAttribute('inert', !isVisible);
  };

  document.addEventListener(
    'keydown',
    (event) => {
      if (!event.key || isEditableTarget(event.target)) return;

      const key = event.key.toLowerCase();

      if (key === 'm') {
        mPressed = true;
        return;
      }

      if (key === 'f' && mPressed) {
        setVisible(!isVisible);
        mPressed = false;
        return;
      }

      mPressed = false;
    },
    { signal }
  );

  document.addEventListener(
    'keyup',
    (event) => {
      if (!event.key || isEditableTarget(event.target)) return;

      if (event.key.toLowerCase() === 'm') {
        window.setTimeout(() => {
          mPressed = false;
        }, 100);
      }
    },
    { signal }
  );
}

for (const root of document.querySelectorAll('[data-designed-by-mf]')) {
  if (root instanceof HTMLElement) {
    initDesignedByMf(root);
  }
}
